import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import styles from './index.module.scss.js';

var _excluded = ["tag", "size", "align", "children", "className", "desktopSize", "subHeading", "wrapperClassName", "showLineAccent"];
var Heading = _ref => {
  var {
      tag,
      size,
      align,
      children,
      className,
      desktopSize,
      subHeading,
      wrapperClassName,
      showLineAccent
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // to map to different nodes
  var HeadingTag = tag;
  var desktopClassSize = desktopSize || size;
  var legacyClasses = {
    [styles.xlarge]: size === 'xlarge',
    [styles.large]: size === 'large',
    [styles.medium]: size === 'medium',
    [styles.small]: size === 'small',
    [styles.xsmall]: size === 'xsmall',
    [styles.xxsmall]: size === 'xxsmall',
    [styles.desktopXlarge]: desktopClassSize === 'xlarge',
    [styles.desktopLarge]: desktopClassSize === 'large',
    [styles.desktopMedium]: desktopClassSize === 'medium',
    [styles.desktopSmall]: desktopClassSize === 'small',
    [styles.desktopXsmall]: desktopClassSize === 'xsmall',
    [styles.desktopXxsmall]: desktopClassSize === 'xxsmall',
    ["lll-text-".concat(align)]: align
  };
  var classes = size ? legacyClasses : {
    [styles.heading]: true
  };
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement(HeadingTag, _extends({
    className: cs(className, {
      ['lll-line-accent']: showLineAccent
    }, _objectSpread2({}, classes))
  }, otherProps), children), !!subHeading && /*#__PURE__*/React.createElement("p", {
    className: cs(styles.subHeading, 'lll-text-body-2')
  }, subHeading));
};
var propTypes = {
  /** The html tag for markup */
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  /** DEPRECATED. The heading's font size
   * xlarge follows H1 from DSM, xxsmall follows H6 from DSM, etc.
   */
  size: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small', 'xsmall', 'xxsmall']),
  /** DEPRECATED. Optional separate size for desktop breakpoint. Use to
   * set different relative sizes for desktop and mobile
   * breakpoints. Defaults to match size prop. */
  desktopSize: PropTypes.oneOf(['xlarge', 'large', 'medium', 'small', 'xsmall', 'xxsmall']),
  /** The heading's content */
  children: PropTypes.node.isRequired,
  /** Class to add to the heading tag */
  className: PropTypes.string,
  /** DEPRECATED. The heading's text alignment */
  align: PropTypes.oneOf(['left', 'center', 'right']),
  subHeading: PropTypes.string,
  /** Class to add to the wrapper element */
  wrapperClassName: PropTypes.string,
  /** Prop to add to the red line accent */
  showLineAccent: PropTypes.bool,
  /** The id for the tag. Used for anchor links.  */
  id: PropTypes.string
};
var defaultProps = {
  className: null,
  desktopSize: null,
  tag: 'h2',
  align: 'left',
  subHeading: '',
  size: null,
  wrapperClassName: '',
  showLineAccent: false,
  id: ''
};
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

export { Heading, Heading as default, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
